<template>
  <li
    :class="[
      'rsp__status-item',
      {
        '--check': ruleStatus
      }
    ]"
  >
    <span class="rsp__item-icon-c">
      <span
        v-show="ruleStatus"
        class="rsp__item-icon"
      >
        <CheckIcon />
      </span>
      <span
        v-show="!ruleStatus"
        class="rsp__item-point"
      >
        •
      </span>
    </span>
    <span class="rsp__item-text">
      {{ ruleDescription }}
    </span>
  </li>
</template>

<script>
  import CheckIcon from '@/assets/icons/check-status.svg';

  export default {
    name: 'StatusItem',
    components: {
      CheckIcon
    },
    props: {
      ruleStatus: {
        type: Boolean,
        default: false,
        required: true
      },
      ruleDescription: {
        type: String,
        default: '',
        required: true
      }
    }
  };
</script>

<style lang="scss" scoped>
  .rsp__status-item {
    display: flex;
    flex-wrap: nowrap;

    &.--check {
      .rsp__item-text {
        color: #4caf50;
      }
    }

    .rsp__item-text {
      font-size: 16px;
      font-weight: 400;
      line-height: 22px;
      color: #998f8a;
      text-align: left;
      padding: 0 8px;
    }

    .rsp__item-icon-c {
      min-width: 12px;
      width: 12px;
      height: 22px;

      display: flex;
      align-items: center;
      justify-content: center;

      .rsp__item-point {
        font-size: 16px;
        font-weight: 400;
        line-height: 22px;
        color: #998f8a;
      }

      .rsp__item-icon {
        margin-top: -2px;
      }

      svg {
        min-width: 12px;
        width: 12px;
        height: 12px;
      }
    }
  }

  @media (max-width: 485px) {
    .rsp__status-item {
      .rsp__item-text {
        font-size: 12px !important;
        line-height: 16px !important;
      }

      .rsp__item-icon-c {
        min-width: 8px !important;
        width: 8px !important;
        height: 16px !important;

        .rsp__item-point {
          font-size: 12px !important;
          line-height: 16px !important;
        }

        svg {
          min-width: 8px !important;
          width: 8px !important;
          height: 8px !important;
        }
      }
    }
  }
</style>
